import {
    Box,
    Typography,
    Button,
    Avatar,
    Chip,
    IconButton,
    Link as MuiLink,
    Grid,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useEffect, useState } from "react";
import CreateContentModal from "modules/MyContent/components/MyContentData/CreateContentModal";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import VideoViewer from "./VideoViewer";
import CourseContent from "./CourseContent";
import { Purchase } from "types";
import { useParams } from "react-router-dom";
import { PurchasesService } from "services/PurchasesService";
import dayjs from "dayjs";
import { ContentsService } from "services/ContentsService";

const courseData = [
    {
        section: "Drawing Fundamentals 1: Basic Skills & Sketching Accurately",
        videos: [
            {
                title: "Structuralism",
                url: `${process.env.PUBLIC_URL}/testVideo.mp4`,
            },
            {
                title: "Functionalism",
                url: "https://www.youtube.com/watch?v=nhbozauzVwM",
            },
            {
                title: "Psychoanalysis",
                url: "https://www.youtube.com/shorts/R_w0dtVOHms",
            },
            { title: "Behaviorism", url: `${process.env.PUBLIC_URL}/testVideo.mp4` },
        ],
    },
    // Add more sections as needed
];

const courseDocData = [
    {
        section: "Drawing Fundamentals 1: Basic Skills & Sketching Accurately",
        files: [
            {
                title: "Structuralism",
                url: `${process.env.PUBLIC_URL}/test.pdf`,
                type: "pdf",
            },
            {
                title: "Functionalism",
                url: `${process.env.PUBLIC_URL}/testpdf2.pdf`,
                type: "pdf",
            },
            {
                title: "Psychoanalysis",
                url: `${process.env.PUBLIC_URL}/test.pdf`,
                type: "pdf",
            },
        ],
    },
    // Add more sections as needed
];

const EduContentCourseData = () => {
    const { id } = useParams<{ id: string }>();


    const [overViewCourseData, setOverViewCourseData] = useState<
        Purchase[] | null
    >(null);
    const [purchaseId, setPurchaseId] = useState<string | null>(null);
    const [activeSection, setActiveSection] = useState("expect");
    const [currentVideo, setCurrentVideo] = useState({
        url: `${process.env.PUBLIC_URL}/testVideo.mp4`,
        type: "video",
    });

    useEffect(() => {
        const fetchData = async () => {
            if (!id) {
                console.error("Purchase ID is undefined");
                return;
            }

            try {
                // Fetch the purchase by its ID
                const purchasedData = await PurchasesService.getPurchasesed(id);

                if (!purchasedData) {
                    console.warn("No purchase found for this ID.");
                    return;
                }

                // Fetch user data related to the purchase
                // const userData = await ContentsService.getUserByCreatedBy(
                //     purchasedData?.contentData?.createdBy
                // );

                // console.log("Fetched user data:", userData);

                if (purchasedData) {
                    setOverViewCourseData([purchasedData]); // Wrap in an array for consistency
                    setPurchaseId(purchasedData.id); // Set the purchase ID
                } else {
                    console.warn("No purchase found for this ID.");
                }
            } catch (error) {
                console.error("Error fetching purchase data:", error);
            }
        };

        fetchData();
    }, [id]);

    useEffect(() => {
        if (purchaseId) {
            // Additional logic using `purchaseId` can go here
        }
    }, [purchaseId]);

    const handleDocumentChange = (doc: { url: string; type: string }) => {
        setCurrentVideo(doc);
    };
    const handleSectionChange = (section: string) => {
        setActiveSection(section);
    };

    return (
        <Box sx={styleSheet.mainContainer}>
            {overViewCourseData?.map((purchase) => (
                <>
                    <Box sx={styleSheet.headerContainer}>
                        {purchase?.contentData?.title}

                    </Box>
                    <Box
                        display={"flex"}
                        flexDirection={"column"}
                        gap={2}
                        px={{ xs: 1, md: 0 }}
                    >
                        <Box
                            display={"flex"}
                            gap={1}
                            flexDirection={{ xs: "column", md: "row" }}
                        >
                            <VideoViewer videoUrl={currentVideo} purchase={purchase} />
                            <Box sx={styleSheet.cardContainer}>
                                <CourseContent
                                    courseDocData={courseDocData}
                                    courseData={courseData}
                                    onVideoSelect={handleDocumentChange}
                                    purchase={purchase}
                                />
                            </Box>
                        </Box>
                        {/* /// one row data /// */}
                        <Box
                            display={"flex"}
                            gap={{ xs: 0, md: 3 }}
                            alignItems={"center"}
                            pt={1}
                            flexWrap={{ xs: "nowrap", md: "wrap" }}
                            overflow={{ xs: "auto", md: "visible" }}
                            sx={{
                                scrollbarWidth: "none", // Hide scrollbar on Firefox
                                "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar on Chrome, Safari, and Edge
                            }}
                        >
                            <Grid
                                display={"flex"}
                                minWidth={{ xs: "200px", md: "0px" }}
                                alignItems={"center"}
                                gap={1}
                            >
                                <Avatar
                                    alt="Remy Sharp"
                                    src={
                                        purchase?.contentData?.createdBy?.profileUrl ||
                                        "/static/images/avatar/1.jpg"
                                    }
                                    sx={{ width: 40, height: 40 }}
                                />
                                <Box fontSize={"17px"} fontWeight={700} color={"#000000"}>
                                    {purchase?.contentData?.createdBy?.firstName}{" "}
                                    {purchase?.contentData?.createdBy?.lastName}
                                </Box>
                            </Grid>
                            <Grid
                                display={"flex"}
                                minWidth={{ xs: "320px", md: "0px" }}
                                alignItems={"center"}
                                gap={1}
                            >
                                <img
                                    src="/assets/icons/sourceOfKnowledge.svg"
                                    alt="course"
                                    style={{ width: "30px", height: 30, objectFit: "cover" }}
                                />
                                <Box sx={styleSheet.textHeading}>
                                    {" "}
                                    {/* {purchase?.contentData?.sourceOfKnowledge} */}
                                    {Array.isArray(purchase?.contentData?.sourceOfKnowledge)
                                        ? purchase?.contentData?.sourceOfKnowledge.join(", ")
                                        : purchase?.contentData?.sourceOfKnowledge.replace(/\//g, " / ")}
                                </Box>
                            </Grid>
                            <Grid
                                display={"flex"}
                                minWidth={{ xs: "300px", md: "0px" }}
                                alignItems={"center"}
                                gap={1}
                            >
                                <img
                                    src="/assets/icons/categoryReview.svg"
                                    alt="course"
                                    style={{ width: "30px", height: 30, objectFit: "cover" }}
                                />
                                <Box sx={styleSheet.textHeading}>
                                    {/* {purchase?.contentData?.category} */}
                                    {Array.isArray(purchase?.contentData?.category)
                                        ? purchase?.contentData?.category.join(", ")
                                        : purchase?.contentData?.category.replace(/\//g, " / ")}
                                </Box>
                            </Grid>
                            <Grid
                                display={"flex"}
                                minWidth={{ xs: "115px", md: "0px" }}
                                alignItems={"center"}
                                gap={1}
                            >
                                <img
                                    src="/assets/icons/iconType.svg"
                                    alt="course"
                                    style={{ width: "30px", height: 30, objectFit: "cover" }}
                                />

                                <Box sx={styleSheet.textHeading}>
                                    {purchase?.contentData?.type}
                                </Box>
                            </Grid>
                            <Grid display={"flex"} alignItems={"center"} gap={1}>
                                <img
                                    src="/assets/icons/calandar.svg"
                                    alt="user"
                                    style={{ width: 26, height: 26 }}
                                />
                                <Box sx={styleSheet.textHeading}>
                                    {purchase?.contentData?.createdAt
                                        ? dayjs(purchase.contentData.createdAt.toDate()).format(
                                            "MM/DD/YYYY"
                                        )
                                        : "No Date Available"}
                                </Box>
                            </Grid>
                        </Box>
                        <Typography
                            sx={{ borderBottom: "1px solid #F0F0F0", mt: 2 }}
                        ></Typography>
                        <Box display={"flex"} flexDirection={"column"} gap={1}>
                            <Box display={"flex"} gap={{ xs: 3, md: 8 }}>
                                <Typography
                                    onClick={() => handleSectionChange("expect")}
                                    fontWeight={700}
                                    fontSize={"18px"}
                                    color={activeSection === "expect" ? "#233F91" : "#676767"}
                                    sx={{
                                        position: "relative",
                                        cursor: "pointer",
                                        "&::after": {
                                            content: '""',
                                            position: "absolute",
                                            width: "100%",
                                            height: "4px",
                                            bottom: "-8px",
                                            borderTopRightRadius: "5px",
                                            borderTopLeftRadius: "5px",
                                            left: 0,
                                            backgroundColor:
                                                activeSection === "expect" ? "#233F91" : "transparent",
                                        },
                                    }}
                                >
                                    What to Expect from this Content
                                </Typography>
                                <Typography
                                    onClick={() => handleSectionChange("summary")}
                                    fontWeight={700}
                                    fontSize={"18px"}
                                    color={activeSection === "summary" ? "#233F91" : "#676767"}
                                    sx={{
                                        position: "relative",
                                        cursor: "pointer",
                                        "&::after": {
                                            content: '""',
                                            position: "absolute",
                                            width: "100%",
                                            height: "4px",
                                            bottom: "-8px",
                                            borderTopRightRadius: "5px",
                                            borderTopLeftRadius: "5px",
                                            left: 0,
                                            backgroundColor:
                                                activeSection === "summary" ? "#233F91" : "transparent",
                                        },
                                    }}
                                >
                                    Summary
                                </Typography>
                            </Box>

                            <Typography
                                sx={{ borderBottom: "1px solid #F0F0F0" }}
                            ></Typography>
                        </Box>
                        {activeSection === "expect" && (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                gap={3}
                                px={{ xs: 2, md: 0 }}
                            >
                                <Typography sx={styleSheet.content}>
                                    {purchase?.contentData?.expectations}{" "}
                                </Typography>
                            </Box>
                        )}

                        {activeSection === "summary" && (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                gap={3}
                                px={{ xs: 2, md: 0 }}
                            >
                                <Typography sx={styleSheet.content}>
                                    {purchase?.contentData?.summary}{" "}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </>
            ))}
        </Box>
    );
};

export default EduContentCourseData;

const styleSheet = {
    mainContainer: {
        // width: "1103px",
        p: { xs: 0, md: 5 },
    },
    headerContainer: {
        pt: { xs: 15, md: 3 },
        pb: 3,
        px: { xs: 1, md: 0 },
        fontWeight: 500,
        fontSize: { xs: "23px", md: "28px" },
        color: "#233F91",
        lineHeight: "27.6px",
    },
    cardContainer: {
        borderRadius: "15px",
        display: "flex",
        backgroundColor: "#FBFBFB",
        boxShadow: "0px 1px 1px 1px rgba(0, 0, 0, 0.25)",
        p: 1,
        flexDirection: "column",
        border: "1px solid #F2F2F2",
        gap: 3,
    },
    addToCardBtn: {
        width: "301px",
        height: "57px",
        borderRadius: "15px",
        bgcolor: "#233F91",
        fontSize: "17px",
        fontWeight: "400",
        color: "#fff",
        "&:hover": {
            bgcolor: "#1A73E8",
        },
    },
    textHeading: {
        fontSize: "17px",
        fontWeight: 400,
        color: "#676767",
    },

    content: {
        mt: 2,
        fontSize: { xs: "20px", md: "22px" },
        fontWeight: 400,
        color: "#676767",
    },
};
